import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import AuthShell from "@/components/AuthShell";
import { api, errMsg } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { CheckCircle2 } from "lucide-react";

export default function Claim() {
  const navigate = useNavigate();
  const [form, setForm] = useState({ phone: "", last_name: "", store_number: "" });
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/claim", form);
      setDone(true);
      toast.success("Account verified!");
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setLoading(false);
    }
  };

  if (done) {
    return (
      <AuthShell title="You're verified" subtitle="One more step to finish setup.">
        <div className="rounded-2xl border border-brand-line bg-white p-6 card-shadow">
          <div className="flex items-center gap-3 text-brand">
            <CheckCircle2 className="w-6 h-6" />
            <p className="font-semibold">Account claimed successfully</p>
          </div>
          <p className="text-brand-muted mt-4 leading-relaxed">
            Now log in with the default password <span className="font-mono font-semibold text-brand-ink">Panera1234!</span>
            {" "}— you'll be asked to create your own secure password right away.
          </p>
          <Button data-testid="claim-goto-login" onClick={() => navigate("/login")} className="w-full mt-6 rounded-full brand-btn h-11">
            Continue to log in
          </Button>
        </div>
      </AuthShell>
    );
  }

  return (
    <AuthShell
      title="Claim your account"
      subtitle="Your manager created an account for you. Verify your details to claim it."
      footer={
        <>
          Store not registered yet?{" "}
          <Link to="/help" className="text-brand font-semibold hover:underline">Submit a Help Desk ticket</Link>
        </>
      }
    >
      <form onSubmit={submit} className="space-y-5">
        <div>
          <Label htmlFor="phone">Phone number</Label>
          <Input id="phone" data-testid="claim-phone" value={form.phone} onChange={set("phone")} placeholder="10-digit phone number" className="mt-1.5 border-brand-line bg-white" />
        </div>
        <div>
          <Label htmlFor="last">Legal last name</Label>
          <Input id="last" data-testid="claim-lastname" value={form.last_name} onChange={set("last_name")} placeholder="Last name" className="mt-1.5 border-brand-line bg-white" />
        </div>
        <div>
          <Label htmlFor="store">Store number</Label>
          <Input id="store" data-testid="claim-store" value={form.store_number} onChange={set("store_number")} placeholder="e.g. 1024" className="mt-1.5 border-brand-line bg-white" />
        </div>
        <Button type="submit" data-testid="claim-submit" disabled={loading} className="w-full rounded-full brand-btn h-11">
          {loading ? "Verifying..." : "Verify & claim"}
        </Button>
      </form>
    </AuthShell>
  );
}
